import type { Comment } from "@/types/const.types"
import { findElementFromPath } from "./find-element-from-path"

export const scrollToComment = (comment: Comment): Promise<void> => {
	return new Promise((resolve) => {
		// Find the target element
		const targetElement = findElementFromPath(comment.targetPath)

		if (!targetElement) {
			console.warn("Target element not found for comment:", comment.id)
			resolve()
			return
		}

		// Ensure the target element is visible (expand any collapsed parents if needed)
		// This is a basic implementation - you might need more specific logic for your UI
		const ensureElementVisible = (element: HTMLElement) => {
			let parent = element.parentElement
			while (parent) {
				// If the parent has display: none or visibility: hidden, we might need to handle it
				const style = window.getComputedStyle(parent)
				if (style.display === "none" || style.visibility === "hidden") {
					// Log for debugging - in a real app you'd handle specific cases
					console.warn(
						"Found hidden parent element that might need to be expanded",
					)
				}
				parent = parent.parentElement
			}
		}

		ensureElementVisible(targetElement)

		// Get the element's current position
		const rect = targetElement.getBoundingClientRect()

		// Calculate the comment's exact position within the element
		const commentX = rect.left + rect.width * comment.xPercentOffset
		const commentY = rect.top + rect.height * comment.yPercentOffset

		// Calculate the scroll position needed to center the comment in viewport
		const targetScrollX = window.scrollX + commentX - window.innerWidth / 2
		const targetScrollY = window.scrollY + commentY - window.innerHeight / 2

		// Scroll to the comment location
		window.scrollTo({
			left: Math.max(0, targetScrollX),
			top: Math.max(0, targetScrollY),
			behavior: "smooth",
		})

		// Resolve after scroll animation completes
		setTimeout(resolve, 150)
	})
}
